import type { ColorProps } from '@chakra-ui/react'
import type { IconDefinition } from '@fortawesome/fontawesome-common-types'
import {
  faBoltLightning,
  faGraduationCap,
  faHatWizard,
  faSeedling,
  faShieldCheck,
  faWandMagicSparkles,
} from '@fortawesome/pro-solid-svg-icons'

import type { AugmentedWorldLevel } from './types'

export const WORLD_LEVEL_TO_UI_DETAILS: Record<
  AugmentedWorldLevel,
  {
    tagTextColor: ColorProps['color']
    tagBgColor: ColorProps['color']
    iconColor: ColorProps['color']
    icon: IconDefinition
  }
> = {
  member: {
    tagTextColor: 'success.fg',
    tagBgColor: 'success.subtle',
    iconColor: 'success.solid',
    icon: faSeedling,
  },
  tutor: {
    tagTextColor: 'info.fg',
    tagBgColor: 'info.subtle',
    iconColor: 'info.solid',
    icon: faGraduationCap,
  },
  'senior-tutor': {
    tagTextColor: 'cyan.fg',
    tagBgColor: 'cyan.subtle',
    iconColor: 'cyan.solid',
    icon: faBoltLightning,
  },
  coach: {
    tagTextColor: 'yellow.fg',
    tagBgColor: 'yellow.subtle',
    iconColor: 'yellow.solid',
    icon: faHatWizard,
  },
  moderator: {
    tagTextColor: 'secondary.fg',
    tagBgColor: 'secondary.subtle',
    iconColor: 'secondary.solid',
    icon: faShieldCheck,
  },
  admin: {
    tagTextColor: 'pink.fg',
    tagBgColor: 'pink.subtle',
    iconColor: 'pink.solid',
    icon: faWandMagicSparkles,
  },
}
